const ImageBlock = ({text}) => {
    return <p className={`re-paragraph`} dangerouslySetInnerHTML={{__html: text}} />;
};

export default ImageBlock;
